import React from 'react'
import './blogs.css'
const Krishan_Kumar = () => {
    return (
        <div className='blog'>
            <div className='container-fluid'>
                <div className='row blog-row'>
                    <div className='col-md-4'>
                        <img src='placement-postulates/dp/Krishan-Kumar.jpg' className='blog-dp' alt='aryaman'></img>
                    </div>
                    <div className='col-md-8'>
                        <div className='blog-head'>
                            <h2>Krishan Kumar</h2>
                            <small>Placed in Sterlite Technology</small>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div>
                        <p>
        Starting with a brief intro of mine, I am Krishan Kumar, Y17 BT Civil Engineering. I got Placed on Day 2 in a
        Company named Sterlite Technology in my very first interview. I had 3 shortlists till day 3. I have a slightly
        different trajectory
        from a normal student. I was a Coordinator of the Student Opinion Society. Apart from that, I was Secretary of
        Electronics Club, Quiz Club, and Ritambhara(Antaragni). These clubs helped a lot in my overall Personality
        development. I got my
        second-year internship at Panasonic India because of the knowledge I got in the Electronics Club. I decided not
        to sit for a 3rd-year intern session after my corporate experience in Panasonic and rather explore other things.
        I thought I would
        get a taste of a Foreign Research Internship. I got selected to pursue my academic research at Tokyo University
        in Environmental Engineering but didn't get any Scholarship owing to Low CPI. I was searching for alternatives
        to get some sort of
        financial help but Corona came and my internship got canceled as my research area was pertinent to the use of
        Labs. I managed to do an Internship in the Centre of Policy Research (on Public Policy) and ML project at the
        end of 3rd year of
        Summer.
      </p><img class="blog-image-left" src="placement-postulates/blogs/Krishan-Kumar/2.jpg"/>
      <p>
        I will be mostly quoting seniors, blogs I read, and personal experiences I have gone through. Everybody is
        different, everyone has unique strengths and weaknesses. What may have worked for me, may not work for you or
        others. So take these
        pieces of advice according to a pinch of salt.
      </p>
      <p>
        Placement is, I think, one of the most important experiences of college life. Not because it will decide your
        future life, but because you will learn a lot of things during this time! From the chaapu dudes to the dumbest
        non-productive-ghissus,
        from the super-genius-gods to backbencher-lukkhas, everyone is damn serious and tense.<b> It will teach you how
          to lie, how to become selfish, what is jealousy but also it will give you the taste of true friendship, the
          feeling of being
          actually happy for a friend, the importance of people in your life, and most importantly how to
          ‘keep-calm-and-have-faith’. It will teach you how to keep your cool when the world around you is going mad,
          how to take failures and learn from
          them, how to forget disappointment in five minutes and move on.</b> It will teach you how to never give up.
        It’s not about how hard you get hit, it’s about how hard you can take it, and bounce back.
      </p><img class="blog-image-right" src="placement-postulates/blogs/Krishan-Kumar/3.jpg"/>
      <p>
        The whole semester is undeniably going to be tough and a lot of us have gone through high stress and anxiety
        during this period but I would say all of us have come out every bit stronger. Rather than dreading the
        placements, look at it as a
        learning opportunity. It will in general help you to grow and make a different person altogether. Every senior
        you talk to would have a unique story to share and diverse advice to give.
      </p>
      <p>
        <b>Decision-</b> Decide whether you want to go for Dual or not before 4th Year starts. Consult with your branch
        seniors. Don't decide based on peer pressure. Keep your 7th semester light.
      </p>
      <p>
        <b>Resume-</b> Making a resume should be an iterative process, that ought to make perfect, Start Preparing
        Early. Make it error-free, create drafts, and get them reviewed by seniors, repeat this process multiple times.
        Additionally, as some
        senior said to me - there should be a story for every point in a Resume. First, because the story seems
        believable and it helps to connect you with the interviewer as they have gone through similar kind of
        experiences (how memorable you are to
        the Interviewer)
      </p><img class="blog-image-left" src="placement-postulates/blogs/Krishan-Kumar/4.jpg"/>
      <p>
        Second, you are not just making the Statements - <b>Stories are 22 times more memorable than facts.</b>
      </p>
      <p>
        <b>CGPA</b> is undoubtedly one of the most crucial aspects of your resume as it is, in some sense, a
        quantitative measure of your academic college life. But let me be clear, it is not the only selection criteria.
        Once you get an interview, if
        you are relevant for the job profile, no matter what your CGPA is, you will get selected if you have prepared
        well for the interview. CPI plays a particular role, but you can do nothing about that now, make your other
        fronts secure. Good grades
        sometimes lead to bad outcomes because good grades signal the interviewer that you might leave the company and
        go for a Master's or MBA. Some motivation for those who have less cpi - think in this way (Always see the
        positive side in every
        situation 😉)
      </p>
      <p>
        <b>Coding-</b> Start Early. Also, as told by my Friend Rajat-Many of the questions are repeated from last year
        or the company visiting some other campus, so make sure you solve previous questions thoroughly before going for
        the tests because
        these tests are often the only criteria for shortlisting. Choose one platform and be regular with them.
      </p><img class="blog-image-right" src="placement-postulates/blogs/Krishan-Kumar/5.jpg"/>
      <p>
        <b>Core companies</b> are almost non-existent, and even if they come, they might not open for you if you have a
        CPI of 7.99. If you are in a dilemma of whether to code or prepare for core, please make this decision before
        4th Year starts!
      </p>
      <p>
        Do not ignore the <b>Aptitude test</b>. If required prepare separately (Sometimes it's the only criteria for
        getting shortlisted) - Refer to Prepleaf or Pariksha site
      </p>
      <p>
        Target only 2-3 sectors and focus on that. Don’t apply for every job profile under peer pressure or out of
        desperation because it will reduce the preparation time you have for the sectors you are really targeting and
        more importantly if you
        manage to get shortlisted for many of them, it’ll make your schedule hectic with tests and interviews you never
        planned on giving in the first place and might lead to unnecessary rejections which can dampen your spirits and
        exhaust you
        physically too.
      </p>
      <p>
        Ensure you have a stable internet connection if you are sitting in the second phase of Placement Drive. I faced
        a lot of issues. I haven't been able to submit a few tests in time due to a weak internet connection.
      </p><img class="blog-image-left" src="placement-postulates/blogs/Krishan-Kumar/6.jpg"/>
      <p>
        <b>Some Advice: Placement Fundae</b><br/>
        These are all based on personal experiences:<br/>
      <ol>
        <li>Placement is an event where you are given a chance to sell yourself. This sentence might seem slightly rude
          to some people but that is the truth. It is an event where a lot of companies will come to buy you by giving
          different packages and
          you are supposed to show why they should hire you.
          <br/><br/>
          <b>Communication and speaking skills matter -</b> how well you present yourself, how you can explain certain
          things to others matters (your persuasion skills) - Corporate job requires you to handle clients and earn
          profit for them. Try to
          build a genuine conversation with the interviewer. It shouldn't be like that interviewer is asking the
          question and you are answering. Think of it as a conversation about the relevant skills and not an interview.
        </li>
        <br/>
        <li>A student with 9 CPI will almost always be preferred over a student with 7 CPI even if both of them perform
          similarly in the interviews.
        </li><br/>
        <img class="blog-image-right" src="placement-postulates/blogs/Krishan-Kumar/7.jpg"/>
        <li>
          A student who doesn’t know Binary Search might get placed on Day 1 whereas a student who knows Kruskal’s
          Minimum Spanning Tree might have to wait till Day 5 just because he was unlucky.
        </li><br/>
        <li>
          You might end up being the only one rejected out of the remaining 5 people who reached the 4th and final round
          after 3 previous elimination rounds.
        </li><br/>
        <li>
          Trust me when I say this, some people get shortlisted in only one company and they convert that offer, but I
          have also seen people getting shortlisted everywhere and still fail to get a single offer.
        </li><br/>
        
        <li>
          Your fate will be decided by a combination of luck and talent/skills. Luck plays a very important role in
          Placements.

        </li><br/>
        <li>
          You can be eliminated based on your answer to interview questions like ‘Please Introduce Yourself’. You can be
          asked anything in the interview from any courses you have done in the first semester to any random Puzzle. And
          You can be rejected
          solely because the puzzle didn't bang you at the time of the interview.
        </li><br/>
        <li>
          Learn from the failure of others. So that you don't end up making the same mistake.
        </li><br/>
        <img class="blog-image-left" src="placement-postulates/blogs/Krishan-Kumar/8.jpg"/>
        <li>
          Be Battle Tested- Take a mock Interview with your friends / Seniors (<b>the more you sweat in training, the
            less you bleed in battle</b>)
        </li><br/>
        <li>
          Do thorough research about the company before the interview. Connect your goals and projects with company
          aspirations. Show them how you know about the company more than the interviewer. I distinctly remember how
          astonished the interviewer
          was when I told him about the company (on being asked about What do you know about us) - Mention their recent
          projects, what award/Recognition they won, Their Stock market scenarios, how are they affected by Covid-19,
          their partnership with
          other firms, their CSR, Unique thing about them, etc.
        </li><br/>
        <li>
          These are the times when you need to have strong control over your thoughts and not be swayed by peer
          pressure. It is important to realize that everyone has different ambitions and values in life and their path
          would be unique. You have to
          know your strengths and weaknesses. There will be occasions when your friends will have more than 10
          shortlists and you don't have even one.
        </li><br/>
        <img class="blog-image-right" src="placement-postulates/blogs/Krishan-Kumar/9.jpg"/>
        <li>
          <b>Patience and persistence</b> matter. I've seen people being rejected by 6–7 companies or maybe even more
          but they didn't give up and kept giving their best in every interview and eventually, they ended up in good
          companies. Keep going for
          the interviews; you will get placed one day. Once you are placed, help your fellow batchmates because you, of
          all people, would know what kind of stress they are under.
          <br/><br/>
          Getting rejected in many interviews could also make you question yourself "Will I get placed or not?" but
          trust me if you stay patient and have faith in your skills, you will get placed
          <br/>(<b>Success is walking from failure to failure with no loss of enthusiasm</b>-'Winston Churchill')

        </li><br/>
        <li>
          Be confident while giving any answer in the interview even if you are wrong
          <br/>
          Most importantly, Seek Help when required.
        </li>
      </ol>
      </p>
      <p>
        I would like to thank everyone present alongside me during these tough days.
      </p>
      <p>
        Also, Don't bother about the factors which are not in your control. Do your best, God will do the rest. One day
        you will be proud of the all the battles you fought silently
      </p>
      <p>

        <b><u>SOURCES OF PREPARATION -</u></b><br/>

      <ul>
        <li><a class="links" href="https://docs.google.com/document/d/1SayYHVAfId5mACsOp0a0bmHJC0wM42gEi8qoxEyav7A/edit"
            target="_blank">Sahil Dhull</a></li>
        <li><a class="links"
            href="https://docs.google.com/document/d/1361vh1zuKTrCXR_DH0WVzJ1cBWjMWJHnpSqtg6jwTOs/edit "
            target="_blank">Product Management Resources</a></li>
        <li><a class="links"
            href="https://docs.google.com/document/d/1az8Ky3LlqaRcRz0ZOE-tAC0KfCHEkfZk5aRzASZmadw/mobilebasic?fbclid=IwAR1Ua72DTRVi9CnPJIp24d6dX9ZL0TtvMJB5vanudavpxPoXe0cgp6WatjE"
            target="_blank">Placement and Intern Preparation by
            Prajual</a></li>
        <li><a class="links"
            href="https://drive.google.com/drive/folders/0B2qQx5DAQoeINUF4cmgwbEk5RXM?fbclid=IwAR1NoEt7xylHcIL8mtoKD2YKAB5fBkN55FvslsQ2gPxx3Dn85zZYoEnLbUg"
            target="_blank">Consulting</a></li>
        <li><a class="links" href="https://www.prepleaf.com/placement-preparation-series"
            target="_blank">Prepleaf/Pariksha</a></li>
        <li><a class="links" href="https://www.youtube.com/watch?v=wHGqp8lz36c" target="_blank">JK Rowling on
            failure</a></li>
      </ul>
      That’s all :-)
      </p>
      <p>
        Thanks for reading this and feel free to reach out with questions, comments or feedback. Extend Help as much as
        possible and Be Thankful 🙂
        Special mention: Rajat Ghosal, Rohit Chauhan, Aayush Ostwal, Vipin, Rohit Dhakate, Kunj Behari, Ankit Agarwal
        (Prepleaf), Mohammad Daud, Ishu, Piyush Paryani for support.
      </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Krishan_Kumar